const WHITE = "#FFFFFF" as const;
const DARK = "#292D33" as const;

function parseHex(input: string | null | undefined): [number, number, number] | null {
  if (!input) return null;
  const raw = input.trim().replace(/^#/, "");
  const hex = raw.length === 3
    ? raw.split("").map((c) => c + c).join("")
    : raw;
  if (hex.length !== 6 || !/^[0-9a-fA-F]{6}$/.test(hex)) return null;
  return [
    parseInt(hex.slice(0, 2), 16),
    parseInt(hex.slice(2, 4), 16),
    parseInt(hex.slice(4, 6), 16),
  ];
}

function channelToLinear(c: number): number {
  const s = c / 255;
  return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
}

/**
 * Picks the glyph color that stays legible on `bg`. Returns "#FFFFFF" for dark
 * backgrounds (relative luminance < 0.55) and "#292D33" for light ones.
 * Falls back to "#FFFFFF" on missing or unparseable input so a legacy brand set
 * with no color still visually matches the current dark letter chip.
 */
export function getReadableIconColor(bg: string | null | undefined): "#FFFFFF" | "#292D33" {
  const rgb = parseHex(bg);
  if (!rgb) return WHITE;
  const [r, g, b] = rgb;
  const luminance =
    0.2126 * channelToLinear(r) +
    0.7152 * channelToLinear(g) +
    0.0722 * channelToLinear(b);
  return luminance < 0.55 ? WHITE : DARK;
}
